var React = require('react');

function IconWomen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#142b6f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}")),React.createElement("circle",{"cx":"20","cy":"13.13","r":"6.51","className":"cls-1","key":1}),React.createElement("path",{"d":"M31.15,32.13c0,.42,0,.83-.06,1.24H8.91c0-.42-.06-.83-.06-1.25,0-6.9,5-12.49,11.15-12.49S31.15,25.23,31.15,32.13Z","className":"cls-1","key":2})]);
}

IconWomen.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 40 40"};

module.exports = IconWomen;

IconWomen.default = IconWomen;
